<h1 *ngIf="datosGetCorreo">{{'SHEDULE2_0.CORREOS.TIPO' + tipoCorreoTag + '.TITULO' | translate}}</h1>
<div fxLayout="row" fxLayoutAlign="space-between center" class="mt-20">
    <button mat-raised-button color="accent" (click)="irPaso(1)">
    <mat-icon class="mr-20">arrow_back</mat-icon>
    {{'SHEDULE2_0.BACK' | translate}}
  </button>
    <mat-form-field *ngIf="datosGetCorreo" fxFlex="30">
        <mat-label>{{'CONSULTATABLA.EDITORMAILODS.SELLANG_L' | translate}}</mat-label>
        <!-- <mat-select [(value)]="idiomaSel"> -->
        <mat-select [(ngModel)]="idiomaElegido" (selectionChange)="eligeIdiomaLista($event.value)">
            <!-- <mat-option *ngFor="let idioma of datosGetCorreo.idiomas; let i = index;" [value]="idioma.idioma" (click)="eligeIdioma(i)"> -->
            <mat-option *ngFor="let idioma of datosGetCorreo.idiomas; let i = index;" [value]="idioma.idioma" (click)="setPosLangMail(i)">
                {{'NOMBREIDIOMAS.'+idioma.idioma | translate}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <ng-container *ngIf="!pasoCompleto">
        <ng-container *ngIf="!pendienteValidacion; else enValidacion">
            <div fxLayout="row" fxLayoutAlign="start center">
                <button *ngIf="modoEdicion" mat-raised-button color="accent" (click)="verInfo()" class="mr-20">
          {{'SHEDULE2_0.EDITOR.BOTONES.INFO' | translate}}
          <mat-icon class="ml-20">info</mat-icon>
        </button>
                <button *ngIf="modoEdicion" mat-raised-button color="primary" (click)="actualizaCorreo()">
          {{'SHEDULE2_0.EDITOR.BOTONES.SAVE' | translate}}
          <mat-icon class="ml-20">save</mat-icon>
        </button>
                <button *ngIf="!modoEdicion && edicion && posicionIdiomaCorreo > -1" mat-raised-button color="accent" (click)="activarEdicion(true)">
          {{'SHEDULE2_0.EDITOR.BOTONES.EDIT' | translate}}
          <mat-icon class="ml-20">edit</mat-icon>
        </button>
            </div>
        </ng-container>
        <ng-template #enValidacion>
            <!-- <div class="roundEdg primary mat-elevation-z4 pr-20 pl-20 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                <h3>{{'SHEDULE2_0.EDITOR.PENDING' | translate}}</h3>
                <mat-icon class="ml-20 s-30">hourglass_empty</mat-icon>
            </div> -->
        </ng-template>
    </ng-container>
</div>
<div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 *ngIf="!idiomaElegido">{{'CONSULTATABLA.EDITORMAILODS.SELLANG' | translate}}</h2>
</div>
<div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="idiomaElegido">
    <mat-form-field fxFlex="50" *ngIf="posicionIdiomaCorreo > -1">
        <mat-label>{{'CONSULTATABLA.EDITORMAILODS.ASUNTO' | translate}}</mat-label>
        <input matInput [(ngModel)]="asuntoCorreo" [disabled]="!modoEdicion">
    </mat-form-field>
</div>
<div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="idiomaElegido">
    <mat-form-field fxFlex="50" *ngIf="posicionIdiomaCorreo > -1">
        <mat-label>{{'CONSULTATABLA.EDITORMAILODS.ASUNTOPILOTO' | translate}}</mat-label>
        <input matInput [(ngModel)]="asuntoCorreoPiloto" [disabled]="!modoEdicion">
    </mat-form-field>
</div>
<editor apiKey="u44q4mabn60a95px2uqtgyeiml3ymlovuzb7ifgfgiwu1q34" *ngIf="datosGetCorreo" #editorMce [init]="opciones" (onChange)="cambioEditor($event)"></editor>
